<template>
  <div class="grid">
    <div>
      <h2 class="section-title">O EasySaúde organiza tudo o que trava o dia</h2>
      <p class="section-subtitle">
        Um sistema que centraliza o fluxo da clínica para você enxergar o que importa, reduzir inconsistências e dar
        segurança para o responsável.
      </p>

      <div class="steps" role="list">
        <div class="step" role="listitem">
          <div class="step-num">1</div>
          <div>
            <div class="step-title">Agenda com controle de atendimentos</div>
            <div class="step-text">Planeje, acompanhe e reduza retrabalho com informações prontas para o time.</div>
          </div>
        </div>
        <div class="step" role="listitem">
          <div class="step-num">2</div>
          <div>
            <div class="step-title">Financeiro com clareza operacional</div>
            <div class="step-text">Organize contas e convênios para tomar decisões com dados consistentes.</div>
          </div>
        </div>
        <div class="step" role="listitem">
          <div class="step-num">3</div>
          <div>
            <div class="step-title">Portal e comunicação para reduzir incerteza</div>
            <div class="step-text">Mais previsibilidade para o responsável e menos chamadas “no improviso”.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="side-card" aria-hidden="true">
      <div class="side-card-header">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
      <div class="side-card-body">
        <div class="bar" />
        <div class="row">
          <div class="chip" />
          <div class="chip short" />
        </div>
        <div class="grid-lines">
          <div class="line" />
          <div class="line" />
          <div class="line" />
          <div class="line" />
          <div class="line" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'SolutionSection' }
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 22px;
  align-items: start;
}

.steps {
  display: grid;
  gap: 14px;
  margin-top: 22px;
}

.step {
  display: flex;
  gap: 14px;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid var(--easy-border);
}

.step-num {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  background: rgba(77, 186, 135, 0.14);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.step-title {
  font-weight: 900;
}

.step-text {
  color: var(--easy-muted);
  margin-top: 5px;
  line-height: 1.55;
  font-size: 14px;
}

.side-card {
  background: #fff;
  border: 1px solid var(--easy-border);
  border-radius: 18px;
  overflow: hidden;
}

.side-card-header {
  padding: 12px 16px;
  display: flex;
  gap: 10px;
  background: rgba(15, 23, 42, 0.03);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.20);
}

.side-card-body {
  padding: 16px;
}

.bar {
  height: 12px;
  width: 64%;
  border-radius: 999px;
  background: rgba(77, 186, 135, 0.18);
  margin-bottom: 16px;
}

.row {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.chip {
  height: 14px;
  width: 45%;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.06);
}

.chip.short {
  width: 30%;
  background: rgba(77, 186, 135, 0.12);
}

.grid-lines {
  display: grid;
  gap: 10px;
}

.line {
  height: 12px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.06);
}

.line:nth-child(2) {
  width: 80%;
}
.line:nth-child(3) {
  width: 92%;
}
.line:nth-child(4) {
  width: 70%;
}
.line:nth-child(5) {
  width: 86%;
}

@media (max-width: 980px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
